var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-cache',{ref:"cache",attrs:{"get-data":_vm.getPartner,"id":this.$route.query.code || ''},scopedSlots:_vm._u([{key:"default",fn:function({data}){return _c('partner-form',{attrs:{"partner":data}})}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }